import { Fixed } from "../Fixed";
import { decimals } from "./decimals";
export class Amount {
    backend;
    currency;
    decimals;
    get value() {
        return this.backend.value;
    }
    get major() {
        return Math.floor(this.backend.value);
    }
    get minor() {
        return this.decimals ? this.backend.value * 10 ** this.decimals : this.backend.value;
    }
    constructor(backend, currency, decimals) {
        this.backend = backend;
        this.currency = currency;
        this.decimals = decimals;
    }
    create(value) {
        return Amount.create(this.currency, value);
    }
    add(term) {
        return this.create(this.backend.add(typeof term == "number" ? term : term.backend).value);
    }
    subtract(minuend) {
        return this.create(this.backend.subtract(typeof minuend == "number" ? minuend : minuend.backend).value);
    }
    multiply(multiplicand) {
        return this.create(this.backend.multiply(typeof multiplicand == "number" ? multiplicand : multiplicand.backend).value);
    }
    convert(factor, to) {
        return Amount.create(to, this.value * factor);
    }
    divide(denominator) {
        return this.create(this.backend.divide(typeof denominator == "number" ? denominator : denominator.backend).value);
    }
    toJSON() {
        return [this.backend.value, this.currency];
    }
    toString() {
        return `${this.backend.toString()} ${this.currency}`;
    }
    static create(currency, value) {
        const d = decimals(currency);
        return new Amount(Fixed.create(value, d ?? 2), currency, d);
    }
    static fromMinor(currency, value) {
        return this.create(currency, value / 10 ** (decimals(currency) ?? 2));
    }
    static add(currency, value, term) {
        return this.create(currency, value).add(term);
    }
    static subtract(currency, value, minuend) {
        return this.create(currency, value).subtract(minuend);
    }
    static multiply(currency, value, multiplicand) {
        return this.create(currency, value).multiply(multiplicand);
    }
    static convert(currency, value, factor, to) {
        return this.create(currency, value).convert(factor, to);
    }
    static divide(currency, value, denominator) {
        return this.create(currency, value).divide(denominator);
    }
}
//# sourceMappingURL=Amount.js.map